"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartItemPromoState = /** @class */ (function () {
    function CartItemPromoState() {
    }
    return CartItemPromoState;
}());
exports.default = CartItemPromoState;
//# sourceMappingURL=EditCapacityState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EditCapacity/EditCapacityState.js
// module id = 2287
// module chunks = 8